@if (!config.hideSidebar) {
    <meta-sidebar [menuItems]="sidebarMenuItems" [userMenuItems]="sidebarUserMenuItems"
        [activeItem]="activeItem$ | async" [hideUserMenu]="config.hideUserMenu || false"
        (statusChanged)="sideBarShown$.next($event)" (menuItemClicked)="handleMenuItemClicked($event.id)"
        (userMenuItemClicked)="handleUserMenuItemClicked($event.id)" />
}

<main id="mainContent" class="min-h-screen bg-body flex flex-col flex-1 transition-all duration-300 pb-6"
    [ngClass]="{'xl:pl-sidebar': sideBarShown$ | async}">
    <section class="pt-6 pb-3 bg-body px-base xl:px-base-desk mb-6 flex-1">
        <div class="flex flex-col-reverse lg:flex-row">
            <div class="w-full flex">
                <div>
                    <h1 class="text-4xl font-bold">{{'FAQ' | translate}}</h1>
                </div>
            </div>
            <div class="flex mb-4 lg:pl-8 lg:ml-auto">
                @if (!hideChatToggler) {
                    <div class="ml-auto">
                        <meta-chat-toggler />
                    </div>
                }
            </div>
        </div>
        <div class="flex flex-col xl:flex-row -mx-4 pt-3">
            <meta-faqs-list class="w-full" [hideTopBar]="true"/>
        </div>
    </section>

    <meta-footer [hideCustomFooter]="hideFooter"/>
</main>
